var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "app-header", class: { "at-top": _vm.isInTop } }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "app-header-menu" }, [
        _c("div", { staticClass: "nav-icon", on: { click: _vm.troggleMenu } }),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "menu-list",
            class: { active: _vm.visiable },
            on: { click: _vm.jumpToTarget }
          },
          [
            _vm.userName
              ? _c("li", { staticClass: "is-mobile menu-item user-name" }, [
                  _c("a", {
                    attrs: { href: "javascript:;" },
                    domProps: {
                      innerHTML: _vm._s(
                        "" +
                          _vm.getConstants("ACCOUNT") +
                          _vm.getConstants("COLON") +
                          " " +
                          _vm.userName
                      )
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "menu-item" }, [
              _c("a", { ref: "home", attrs: { href: "javascript:;" } }, [
                _vm._v(
                  _vm._s(_vm.getConstants("EAGLE_LANDING_HEADER_MENU_HOME"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "menu-item not-mobile" }, [
              _c("a", { attrs: { href: "#app_benifits" } }, [
                _vm._v(
                  _vm._s(_vm.getConstants("EAGLE_LANDING_HEADER_MENU_MORE"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "menu-item" }, [
              _c("a", { attrs: { href: "#app_sale" } }, [
                _vm._v(
                  _vm._s(_vm.getConstants("EAGLE_LANDING_HEADER_MENU_PRICING"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "menu-item not-mobile" }, [
              _c("a", { attrs: { href: "#app_more" } }, [
                _vm._v(
                  _vm._s(_vm.getConstants("EAGLE_LANDING_HEADER_MENU_FEATURES"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "menu-item" }, [
              _c("a", { attrs: { href: "#app_faq" } }, [
                _vm._v(
                  _vm._s(_vm.getConstants("EAGLE_LANDING_HEADER_MENU_FAQ"))
                )
              ])
            ]),
            _vm._v(" "),
            !_vm.userName && !_vm.isWechat
              ? _c("li", { staticClass: "menu-item" }, [
                  _c("a", { attrs: { href: _vm.loginHref } }, [
                    _vm._v(
                      _vm._s(
                        _vm.getConstants("EAGLE_LANDING_HEADER_MENU_SIGNIN")
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.userName && !_vm.isWechat
              ? _c("li", { staticClass: "menu-item" }, [
                  _c("a", { attrs: { href: _vm.signUpHref } }, [
                    _vm._v(
                      _vm._s(
                        _vm.getConstants("EAGLE_LANDING_HEADER_MENU_SIGNUP")
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "not-mobile menu-item buy" }, [
              _c(
                "a",
                {
                  attrs: { href: "javascript:;" },
                  on: { click: _vm.freeTrialClick }
                },
                [_vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_COMMON_FREE")))]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "is-mobile menu-item" }, [
              _c(
                "a",
                {
                  attrs: { href: "javascript:;" },
                  on: { click: _vm.freeTrialClick }
                },
                [_vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_COMMON_FREE")))]
              )
            ]),
            _vm._v(" "),
            _vm.userName
              ? _c(
                  "li",
                  {
                    ref: "logout",
                    staticClass: "not-mobile menu-item user-name",
                    class: { active: _vm.logoutVisiable },
                    on: {
                      click: function($event) {
                        _vm.logoutVisiable = !_vm.logoutVisiable
                      }
                    }
                  },
                  [
                    _c("a", {
                      staticClass: "css-ellipsis",
                      attrs: { href: "javascript:;" },
                      domProps: { innerHTML: _vm._s(_vm.userName) }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "logout" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:;" },
                          on: { click: _vm.logout }
                        },
                        [_vm._v(_vm._s(_vm.getConstants("LOGOUT")))]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.userName
              ? _c("li", { staticClass: "is-mobile menu-item red" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:;" },
                      on: { click: _vm.logout }
                    },
                    [_vm._v(_vm._s(_vm.getConstants("LOGOUT")))]
                  )
                ])
              : _vm._e()
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "menu-bg is-mobile",
      class: { active: _vm.visiable },
      on: {
        click: function($event) {
          _vm.visiable = false
        }
      }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "app-header-logo", attrs: { href: "/" } }, [
      _c("img", {
        attrs: { src: require("../images/svg/normal.svg"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }